// SocialLoginComposables.js
import store from "@/vuex/store";

export function isSocialLogin() {
    return store.getters.getIsSocialLogin === true;
}
